import type { UserStore } from "../../../stores/user";

const userStore: Partial<UserStore> = {
  user: {
    first_name: "J",
    last_name: "D",
    email: "developers",
    phone: "a"
  },
  hasLoaded: true
};

export default {
  userStore
};
